export default "__VITE_ASSET__CUNiOJ_l__"